<template>
  <div class="time-field">
<!--    <h5>{{label}}</h5>-->
    <DatePicker
      class="date-picker"
      :placeholder="label"
      :clearable="false"
      type="time"
      v-model="localTime"
      @change="updateTime"
      format="HH-mm"
      :disabled-time="disabledDates"
    />
  </div>
</template>

<script>
  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'
  import 'vue2-datepicker/locale/ru'

  export default {
    name: "TimeField",

    components: { DatePicker },

    props: {
      time: {
        type: String,
      },
      label: {
        type: String,
      },
      min: {
        type: String,
      },
      max: {
        type: String,
      }
    },

    created() {
      if(this.time) this.localTime = new Date(this.time)
    },

    data() {
      return {
        localTime: null,
      }
    },

    methods: {
      disabledDates(date) {
        if (this.min) return date < new Date(this.min)
        // if (this.max) return date < new Date(this.min)
      },

      updateTime(value) {
        this.$emit('updateTime', value)
      },
    },

    watch: {
      time() {
        this.localTime = this.time ? new Date(this.time) : null
      }
    }
  }
</script>

<style scoped>

>>>.mx-input {
  border-radius: 20px;
  height: 40px;
  padding: 0 20px;
}

>>>.mx-icon-calendar {
  right: 30px;
}

.date-picker {
  width: 100%;
}

h5 span {
  color: red;
}
</style>
